import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { isStringEmpty } from '@common/helpers';
import { SpecialAssistanceRequestState } from '@common/helpers/constants/my-booking/passenger-information-input-modal.state';
import { MListData } from '@common/interfaces';
import { SpecialAssistanceRequestWalkingAbilityData } from '@common/interfaces/mybooking/modals/passenger-information-input/special-assistance-request-modal.interface';
import { ValidationErrorInfo } from '@lib/interfaces/validate';

/**
 * サポート情報入力モーダル
 */
@Component({
  selector: 'asw-special-assistance-request-modal-walking-ability',
  templateUrl: './special-assistance-request-modal-walking-ability.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialAssistanceRequestModalWalkingAbilityComponent implements OnInit, OnDestroy {
  @Input()
  get data() {
    return this._data;
  }
  set data(value: SpecialAssistanceRequestWalkingAbilityData | undefined) {
    this._data = value;
  }
  private _data?: SpecialAssistanceRequestWalkingAbilityData;

  @Input()
  set master(value: Array<MListData>) {
    this._master = value;
  }
  get master(): Array<MListData> {
    return this._master;
  }
  private _master: Array<MListData> = [];

  @Output()
  dataChange: EventEmitter<SpecialAssistanceRequestWalkingAbilityData> =
    new EventEmitter<SpecialAssistanceRequestWalkingAbilityData>();

  public id = this.constructor.name;
  public code = '';
  public error: ValidationErrorInfo | null = null;

  constructor(private _change: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.refresh();
  }

  ngOnDestroy(): void {
    this.apply();
  }

  refresh() {
    this.code = this.data?.code ?? '';
    this._change.markForCheck();
  }

  apply() {
    const value: SpecialAssistanceRequestWalkingAbilityData = { code: this.code };
    this.data = value;
    this.dataChange.emit(value);
  }

  /**
   * 歩行程度変更処理
   * @param code 歩行程度コード（SSRコード）
   */
  changeCode(code: string) {
    if (!isStringEmpty(code)) {
      this.code = code;
      this.error = null;
    }
  }

  /**
   * エラー判定
   * @returns 判定結果
   */
  isError() {
    if (!this.code) {
      this.error = SpecialAssistanceRequestState.WalkingAbility;
      this._change.markForCheck();
      return true;
    }

    return false;
  }
}
